<div class="import-stages-panel">
  <button
    type="button"
    class="import-stages-toggle"
    (click)="toggleCollapsed()"
    [attr.aria-expanded]="!collapsed"
    aria-controls="import-stages-band"
  >
    <i
      class="fa-solid"
      [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
      aria-hidden="true"
    ></i>
    <span>Systeemoverzicht</span>
  </button>

  <div
    *ngIf="!collapsed"
    #band
    id="import-stages-band"
    class="import-stages"
    role="img"
    aria-label="Product import system overview: Productsup, CSVToDatabase, ProductDB, DatabaseToShop, ICM and IOM, with arrows showing the flow direction. Only CSVToDatabase reflects the live import status."
  >
    <!-- Connector track. Drawn in band pixels (no viewBox) behind the factories; the
       opaque factory nodes mask the segments running underneath, and each directed
       arrowhead sits at the segment midpoint, in the gap between two factories. -->
    <svg class="connectors" aria-hidden="true">
      <line
        *ngFor="let connector of connectors"
        class="connector-line"
        [attr.x1]="connector.x1"
        [attr.y1]="connector.y1"
        [attr.x2]="connector.x2"
        [attr.y2]="connector.y2"
      />
      <polygon
        *ngFor="let connector of connectors"
        class="connector-arrow"
        points="-9,-7 9,0 -9,7"
        [attr.transform]="
          'translate(' +
          connector.midX +
          ',' +
          connector.midY +
          ') rotate(' +
          connector.angle +
          ')'
        "
      />
    </svg>

    <div class="stages-grid">
      <div
        class="stage"
        *ngFor="let stage of stages"
        [style.grid-column]="stage.col"
        [style.grid-row]="stage.row"
      >
        <span class="stage-node">
          <span
            class="stage-icon"
            [ngClass]="stageIconClass(stage)"
            [class.stage--pulse]="stage.live && isCsvRunning"
          >
            <app-custom-icon name="factory" classes="fa-3x"></app-custom-icon>
          </span>
          <span class="stage-label" [class.fw-semibold]="stage.live">{{
            stage.label
          }}</span>
        </span>
      </div>
    </div>
  </div>
</div>
